import * as React from "react";
const MenuDoc = (props) => (
  <svg
    width={20}
    height={23}
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.25 22.25H6.25C2.6 22.25 0.5 20.15 0.5 16.5V6.5C0.5 2.85 2.6 0.75 6.25 0.75H14.25C17.9 0.75 20 2.85 20 6.5V16.5C20 20.15 17.9 22.25 14.25 22.25ZM6.25 2.25C3.39 2.25 2 3.64 2 6.5V16.5C2 19.36 3.39 20.75 6.25 20.75H14.25C17.11 20.75 18.5 19.36 18.5 16.5V6.5C18.5 3.64 17.11 2.25 14.25 2.25H6.25Z"
      fill="#4B5155"
    />
    <path
      d="M7.25 10.61C7.08 10.61 6.91 10.58 6.75 10.51C6.29 10.31 6 9.85999 6 9.37V1.5C6 1.09 6.34 0.75 6.75 0.75H13.75C14.16 0.75 14.5 1.09 14.5 1.5V9.35999C14.5 9.85999 14.21 10.31 13.75 10.5C13.3 10.7 12.77 10.61 12.4 10.27L10.25 8.29999L8.09998 10.28C7.85998 10.5 7.56 10.61 7.25 10.61ZM10.25 6.71002C10.55 6.71002 10.86 6.81998 11.1 7.03998L13 8.78998V2.25H7.5V8.78998L9.40002 7.03998C9.64002 6.81998 9.95 6.71002 10.25 6.71002Z"
      fill="#4B5155"
    />
    <path
      d="M15.75 14.25H11.5C11.09 14.25 10.75 13.91 10.75 13.5C10.75 13.09 11.09 12.75 11.5 12.75H15.75C16.16 12.75 16.5 13.09 16.5 13.5C16.5 13.91 16.16 14.25 15.75 14.25Z"
      fill="#4B5155"
    />
    <path
      d="M15.75 18.25H7.25C6.84 18.25 6.5 17.91 6.5 17.5C6.5 17.09 6.84 16.75 7.25 16.75H15.75C16.16 16.75 16.5 17.09 16.5 17.5C16.5 17.91 16.16 18.25 15.75 18.25Z"
      fill="#4B5155"
    />
  </svg>
);
export default MenuDoc;
